import { caseTypeApiSchema } from "@/components/Forms/schema/caseTypeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceCollectionSelector } from "jsonapi-zod-query";

const caseTypeSelector = createResourceCollectionSelector({
    type: "caseType",
    attributesSchema: caseTypeApiSchema,
});

export type CaseForm = ReturnType<typeof caseTypeSelector>;

export const useFetchCaseTypes = (clientId?: string): UseQueryResult<CaseForm> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["case-types", clientId],
        queryFn: async ({ signal }) => {
            const url = apiUrl(`/case-type/for-client/${clientId ?? "all"}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch case types: ${response.statusText}`);
            }

            return await response.json();
        },
        select: caseTypeSelector,
    });
};
